import {
  AccountApiImpl,
  AdminApiImpl,
  AuthenticationApiImpl,
  BaseAPI,
  ConfigurationParameters,
  FrontendApiImpl,
  ImagesApiImpl,
  LookupApiImpl,
  MessagesApiImpl,
  OffersApiImpl,
  OrganisationsApiImpl,
  PostsApiImpl,
  ProjectsApiImpl,
  querystring,
  ResourcesApiImpl,
} from '@/api/generated'
import { Constructor } from '@/types/main'
import { ApiTypes } from '@/api/api'
import { Injector } from '@/config/dependency-injection'
import { fetch } from 'whatwg-fetch'
import { onBootstrap } from '@/bootstrap'
import { ApiMiddlewareToken } from '@/config/injection-tokens'
import './middleware'

onBootstrap.add(() => {
  const ApiConfiguration: ConfigurationParameters = {
    basePath: '/api/v1',
    fetchApi: fetch,
    middleware: Injector.get(ApiMiddlewareToken),
    queryParamsStringify: querystring,
  }

  const ApiFactory = (ApiClass: Constructor<BaseAPI>) => {
    return () => new ApiClass(ApiConfiguration)
  }

  Injector.bindLazy(ApiTypes.AccountApi, ApiFactory(AccountApiImpl))
  Injector.bindLazy(ApiTypes.AdminApi, ApiFactory(AdminApiImpl))
  Injector.bindLazy(ApiTypes.AuthenticationApi, ApiFactory(AuthenticationApiImpl))
  Injector.bindLazy(ApiTypes.FrontendApi, ApiFactory(FrontendApiImpl))
  Injector.bindLazy(ApiTypes.ImagesApi, ApiFactory(ImagesApiImpl))
  Injector.bindLazy(ApiTypes.LookupApi, ApiFactory(LookupApiImpl))
  Injector.bindLazy(ApiTypes.MessageApi, ApiFactory(MessagesApiImpl))
  Injector.bindLazy(ApiTypes.OffersApi, ApiFactory(OffersApiImpl))
  Injector.bindLazy(ApiTypes.OrganisationsApi, ApiFactory(OrganisationsApiImpl))
  Injector.bindLazy(ApiTypes.PostsApi, ApiFactory(PostsApiImpl))
  Injector.bindLazy(ApiTypes.ProjectsApi, ApiFactory(ProjectsApiImpl))
  Injector.bindLazy(ApiTypes.ResourcesApi, ApiFactory(ResourcesApiImpl))
})
